/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetServerOptions200ResponseData } from './GetServerOptions200ResponseData'
import {
  GetServerOptions200ResponseDataFromJSON,
  GetServerOptions200ResponseDataFromJSONTyped,
  GetServerOptions200ResponseDataToJSON,
} from './GetServerOptions200ResponseData'

/**
 *
 * @export
 * @interface GetServerOptions200Response
 */
export interface GetServerOptions200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetServerOptions200Response
   */
  status: boolean
  /**
   *
   * @type {GetServerOptions200ResponseData}
   * @memberof GetServerOptions200Response
   */
  data: GetServerOptions200ResponseData
}

/**
 * Check if a given object implements the GetServerOptions200Response interface.
 */
export function instanceOfGetServerOptions200Response(
  value: object
): value is GetServerOptions200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetServerOptions200ResponseFromJSON(
  json: any
): GetServerOptions200Response {
  return GetServerOptions200ResponseFromJSONTyped(json, false)
}

export function GetServerOptions200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetServerOptions200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetServerOptions200ResponseDataFromJSON(json['data']),
  }
}

export function GetServerOptions200ResponseToJSON(
  value?: GetServerOptions200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetServerOptions200ResponseDataToJSON(value['data']),
  }
}
